// extracted by mini-css-extract-plugin
module.exports = {"unlinkButton":"UnlinkTwitchButton_unlinkButton__WX7Ro","confirmation":"UnlinkTwitchButton_confirmation___b2WN","air":"UnlinkTwitchButton_air__GM6eF"};